var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mostra_status)?_c('md-button',{staticClass:"md-primary",attrs:{"type":"button","disabled":_vm.disableButton},on:{"click":_vm.onclick_status}},[_vm._v(_vm._s(_vm.status != 1 ? "Publicar" : "Despublicar"))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }